export interface PakistanProduct {
  id: string;
  name: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  category: string;
}

export interface PakistanFactory {
  id: string;
  name: string;
  city: string;
  established: number;
  employees: string;
  verified: boolean;
  dropshipping: boolean;
  warehouseCountries?: string[];
  rating: number;
  responseRate: string;
  onTimeDelivery: string;
  productCount: number;
  categories: string[];
  description: string;
  logo: string;
  coverImage: string;
  products: PakistanProduct[];
}

export const pakistanFactories: PakistanFactory[] = [
  {
    id: "pkf1",
    name: "Sialkot Sports & Leather Co.",
    city: "Sialkot",
    established: 1998,
    employees: "500–1000",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Pakistan", "UAE", "Saudi Arabia", "UK", "Germany", "USA", "Australia"],
    rating: 4.9,
    responseRate: "98%",
    onTimeDelivery: "97%",
    productCount: 2800,
    categories: ["Sports Equipment", "Leather Goods", "Footballs"],
    description: "World-renowned Sialkot sports manufacturer producing FIFA-certified footballs, cricket equipment, and premium leather goods. Supplying top global sports brands with full private label and dropshipping support across 7 countries.",
    logo: "https://public.readdy.ai/ai/img_res/37005ab8c1d32b719e9d4ed296ce0282.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=Sialkot%20Pakistan%20sports%20factory%20production%20line%20workers%20sewing%20footballs%20leather%20goods%20professional%20bright%20clean%20modern%20interior&width=800&height=400&seq=pkfc1&orientation=landscape",
    products: [
      {
        id: "pkf1p1",
        name: "FIFA Quality Pro Football (Size 5)",
        samplePrice: 45,
        bulkPrice: 14,
        moq: 50,
        category: "Sports Equipment",
        image: "https://readdy.ai/api/search-image?query=FIFA%20quality%20pro%20football%20size%205%20premium%20white%20background%20product%20photography%20professional%20sports%20equipment%20Pakistan%20Sialkot&width=400&height=400&seq=pkf1p1&orientation=squarish",
      },
      {
        id: "pkf1p2",
        name: "Professional Cricket Bat Kashmir Willow",
        samplePrice: 85,
        bulkPrice: 28,
        moq: 20,
        category: "Sports Equipment",
        image: "https://readdy.ai/api/search-image?query=professional%20cricket%20bat%20Kashmir%20willow%20premium%20white%20background%20product%20photography%20sports%20equipment%20Pakistan&width=400&height=400&seq=pkf1p2&orientation=squarish",
      },
      {
        id: "pkf1p3",
        name: "Genuine Leather Boxing Gloves 16oz",
        samplePrice: 62,
        bulkPrice: 22,
        moq: 30,
        category: "Leather Goods",
        image: "https://readdy.ai/api/search-image?query=genuine%20leather%20boxing%20gloves%2016oz%20premium%20white%20background%20product%20photography%20professional%20sports%20equipment%20Pakistan&width=400&height=400&seq=pkf1p3&orientation=squarish",
      },
    ],
  },
  {
    id: "pkf2",
    name: "Faisalabad Textile Mills Ltd.",
    city: "Faisalabad",
    established: 2003,
    employees: "1000–2000",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Pakistan", "UAE", "Saudi Arabia", "UK", "USA", "Canada", "Netherlands"],
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "96%",
    productCount: 3200,
    categories: ["Textiles", "Cotton Fabric", "Bed Linen"],
    description: "Pakistan's largest cotton textile manufacturer based in Faisalabad — the Manchester of Asia. Producing premium cotton fabrics, bed linen, towels, and home textiles for global retailers with full dropshipping from 7 warehouse locations.",
    logo: "https://readdy.ai/api/search-image?query=textile%20cotton%20company%20logo%20gold%20thread%20emblem%20white%20background%20Faisalabad%20Pakistan%20manufacturing%20corporate%20identity%20elegant%20minimalist&width=80&height=80&seq=pkfl2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Faisalabad%20Pakistan%20textile%20cotton%20factory%20production%20line%20weaving%20looms%20workers%20professional%20bright%20clean%20modern%20interior&width=800&height=400&seq=pkfc2&orientation=landscape",
    products: [
      {
        id: "pkf2p1",
        name: "Premium 100% Cotton Bed Sheet Set (King)",
        samplePrice: 55,
        bulkPrice: 18,
        moq: 30,
        category: "Bed Linen",
        image: "https://readdy.ai/api/search-image?query=premium%20100%20percent%20cotton%20bed%20sheet%20set%20king%20size%20white%20background%20product%20photography%20professional%20home%20textile%20Pakistan&width=400&height=400&seq=pkf2p1&orientation=squarish",
      },
      {
        id: "pkf2p2",
        name: "Egyptian Cotton Towel Set (6pcs)",
        samplePrice: 48,
        bulkPrice: 16,
        moq: 24,
        category: "Textiles",
        image: "https://readdy.ai/api/search-image?query=Egyptian%20cotton%20towel%20set%206pcs%20luxury%20soft%20white%20background%20product%20photography%20professional%20home%20textile%20Pakistan&width=400&height=400&seq=pkf2p2&orientation=squarish",
      },
      {
        id: "pkf2p3",
        name: "Cotton Fabric Roll 100m (240 GSM)",
        samplePrice: 130,
        bulkPrice: 48,
        moq: 10,
        category: "Cotton Fabric",
        image: "https://readdy.ai/api/search-image?query=cotton%20fabric%20roll%20100m%20240%20GSM%20premium%20textile%20material%20white%20background%20product%20photography%20professional%20manufacturing%20Pakistan&width=400&height=400&seq=pkf2p3&orientation=squarish",
      },
    ],
  },
  {
    id: "pkf3",
    name: "Lahore Surgical & Medical Instruments",
    city: "Lahore",
    established: 2000,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.8,
    responseRate: "95%",
    onTimeDelivery: "94%",
    productCount: 1450,
    categories: ["Medical Instruments", "Surgical Tools", "Dental Equipment"],
    description: "ISO-certified surgical and medical instrument manufacturer in Lahore. Producing precision stainless steel surgical tools, dental instruments, and medical equipment exported to hospitals and distributors in over 50 countries worldwide.",
    logo: "https://readdy.ai/api/search-image?query=medical%20surgical%20instruments%20company%20logo%20silver%20stainless%20steel%20emblem%20white%20background%20Lahore%20Pakistan%20corporate%20identity%20professional%20minimalist&width=80&height=80&seq=pkfl3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Lahore%20Pakistan%20surgical%20medical%20instruments%20factory%20clean%20room%20production%20stainless%20steel%20tools%20workers%20professional%20bright%20modern%20interior&width=800&height=400&seq=pkfc3&orientation=landscape",
    products: [
      {
        id: "pkf3p1",
        name: "Stainless Steel Surgical Scissors Set (10pcs)",
        samplePrice: 95,
        bulkPrice: 35,
        moq: 20,
        category: "Surgical Tools",
        image: "https://readdy.ai/api/search-image?query=stainless%20steel%20surgical%20scissors%20set%2010pcs%20precision%20medical%20instruments%20white%20background%20product%20photography%20professional%20Pakistan&width=400&height=400&seq=pkf3p1&orientation=squarish",
      },
      {
        id: "pkf3p2",
        name: "Dental Extraction Forceps Set (12pcs)",
        samplePrice: 120,
        bulkPrice: 45,
        moq: 10,
        category: "Dental Equipment",
        image: "https://readdy.ai/api/search-image?query=dental%20extraction%20forceps%20set%2012pcs%20stainless%20steel%20precision%20instruments%20white%20background%20product%20photography%20professional%20medical&width=400&height=400&seq=pkf3p2&orientation=squarish",
      },
      {
        id: "pkf3p3",
        name: "Surgical Needle Holder Clamp Set",
        samplePrice: 75,
        bulkPrice: 28,
        moq: 20,
        category: "Surgical Tools",
        image: "https://readdy.ai/api/search-image?query=surgical%20needle%20holder%20clamp%20set%20stainless%20steel%20precision%20medical%20instruments%20white%20background%20product%20photography%20professional&width=400&height=400&seq=pkf3p3&orientation=squarish",
      },
    ],
  },
  {
    id: "pkf4",
    name: "Karachi Rice & Basmati Exports",
    city: "Karachi",
    established: 2006,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Pakistan", "UAE", "Saudi Arabia", "UK", "USA", "Qatar", "Kuwait"],
    rating: 4.9,
    responseRate: "97%",
    onTimeDelivery: "96%",
    productCount: 420,
    categories: ["Food & Beverage", "Rice", "Spices"],
    description: "Premium Pakistani Basmati rice and food exporter based in Karachi. Supplying world-famous Super Kernel Basmati, aromatic spices, and halal-certified food products to global retailers and dropshippers across the Middle East, UK, and USA.",
    logo: "https://readdy.ai/api/search-image?query=rice%20food%20export%20company%20logo%20gold%20grain%20emblem%20white%20background%20Karachi%20Pakistan%20food%20corporate%20identity%20elegant%20minimalist&width=80&height=80&seq=pkfl4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Karachi%20Pakistan%20rice%20basmati%20food%20factory%20packaging%20production%20workers%20professional%20bright%20clean%20modern%20interior&width=800&height=400&seq=pkfc4&orientation=landscape",
    products: [
      {
        id: "pkf4p1",
        name: "Super Kernel Basmati Rice 25kg Sack",
        samplePrice: 68,
        bulkPrice: 24,
        moq: 20,
        category: "Rice",
        image: "https://readdy.ai/api/search-image?query=super%20kernel%20basmati%20rice%2025kg%20sack%20premium%20white%20background%20product%20photography%20professional%20food%20Pakistan%20Karachi&width=400&height=400&seq=pkf4p1&orientation=squarish",
      },
      {
        id: "pkf4p2",
        name: "Pakistani Spice Mix Collection (10 jars)",
        samplePrice: 42,
        bulkPrice: 15,
        moq: 30,
        category: "Spices",
        image: "https://readdy.ai/api/search-image?query=Pakistani%20spice%20mix%20collection%2010%20jars%20colorful%20aromatic%20white%20background%20product%20photography%20professional%20food%20Karachi&width=400&height=400&seq=pkf4p2&orientation=squarish",
      },
      {
        id: "pkf4p3",
        name: "Premium Sella Basmati Rice 5kg Gift Box",
        samplePrice: 28,
        bulkPrice: 10,
        moq: 50,
        category: "Rice",
        image: "https://readdy.ai/api/search-image?query=premium%20sella%20basmati%20rice%205kg%20gift%20box%20luxury%20packaging%20white%20background%20product%20photography%20professional%20food%20Pakistan&width=400&height=400&seq=pkf4p3&orientation=squarish",
      },
    ],
  },
  {
    id: "pkf5",
    name: "Peshawar Handcraft & Carpet Studio",
    city: "Peshawar",
    established: 2008,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Pakistan", "UAE", "UK", "Germany", "USA", "France"],
    rating: 4.8,
    responseRate: "94%",
    onTimeDelivery: "93%",
    productCount: 680,
    categories: ["Handcrafts", "Carpets", "Home Decor"],
    description: "Authentic Pakistani handcraft and carpet manufacturer in Peshawar. Producing hand-knotted wool carpets, traditional embroidered textiles, and artisan home decor pieces for global collectors and interior designers.",
    logo: "https://readdy.ai/api/search-image?query=handcraft%20carpet%20company%20logo%20gold%20geometric%20pattern%20emblem%20white%20background%20Peshawar%20Pakistan%20artisan%20corporate%20identity%20elegant&width=80&height=80&seq=pkfl5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Peshawar%20Pakistan%20handcraft%20carpet%20studio%20artisans%20weaving%20traditional%20wool%20carpets%20embroidery%20professional%20bright%20colorful%20interior&width=800&height=400&seq=pkfc5&orientation=landscape",
    products: [
      {
        id: "pkf5p1",
        name: "Hand-Knotted Wool Carpet 3x5m",
        samplePrice: 380,
        bulkPrice: 145,
        moq: 3,
        category: "Carpets",
        image: "https://readdy.ai/api/search-image?query=hand%20knotted%20wool%20carpet%203x5m%20traditional%20Pakistani%20geometric%20pattern%20colorful%20white%20background%20product%20photography%20premium%20home%20decor&width=400&height=400&seq=pkf5p1&orientation=squarish",
      },
      {
        id: "pkf5p2",
        name: "Embroidered Cushion Cover Set (6pcs)",
        samplePrice: 55,
        bulkPrice: 20,
        moq: 12,
        category: "Home Decor",
        image: "https://readdy.ai/api/search-image?query=embroidered%20cushion%20cover%20set%206pcs%20traditional%20Pakistani%20pattern%20colorful%20white%20background%20product%20photography%20premium%20home%20decor&width=400&height=400&seq=pkf5p2&orientation=squarish",
      },
      {
        id: "pkf5p3",
        name: "Traditional Shawl Pashmina Collection",
        samplePrice: 72,
        bulkPrice: 26,
        moq: 15,
        category: "Handcrafts",
        image: "https://readdy.ai/api/search-image?query=traditional%20shawl%20pashmina%20collection%20Pakistani%20luxury%20soft%20colorful%20white%20background%20product%20photography%20premium%20fashion&width=400&height=400&seq=pkf5p3&orientation=squarish",
      },
    ],
  },
  {
    id: "pkf6",
    name: "Gujranwala Steel & Engineering Works",
    city: "Gujranwala",
    established: 2004,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.7,
    responseRate: "93%",
    onTimeDelivery: "92%",
    productCount: 960,
    categories: ["Steel", "Engineering", "Industrial"],
    description: "Major steel and engineering manufacturer in Gujranwala — Pakistan's industrial hub. Producing structural steel, metal fabrication, industrial machinery parts, and engineering components for construction and manufacturing sectors globally.",
    logo: "https://readdy.ai/api/search-image?query=steel%20engineering%20company%20logo%20silver%20industrial%20emblem%20white%20background%20Gujranwala%20Pakistan%20manufacturing%20corporate%20identity%20modern%20minimalist&width=80&height=80&seq=pkfl6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Gujranwala%20Pakistan%20steel%20engineering%20factory%20production%20line%20metal%20fabrication%20workers%20professional%20bright%20industrial%20modern%20interior&width=800&height=400&seq=pkfc6&orientation=landscape",
    products: [
      {
        id: "pkf6p1",
        name: "Structural Steel I-Beam 6m (100x50mm)",
        samplePrice: 185,
        bulkPrice: 68,
        moq: 10,
        category: "Steel",
        image: "https://readdy.ai/api/search-image?query=structural%20steel%20I-beam%206m%20industrial%20construction%20material%20white%20background%20product%20photography%20professional%20engineering%20Pakistan&width=400&height=400&seq=pkf6p1&orientation=squarish",
      },
      {
        id: "pkf6p2",
        name: "Stainless Steel Pipe Set (10pcs)",
        samplePrice: 145,
        bulkPrice: 52,
        moq: 10,
        category: "Steel",
        image: "https://readdy.ai/api/search-image?query=stainless%20steel%20pipe%20set%2010pcs%20industrial%20construction%20material%20white%20background%20product%20photography%20professional%20engineering%20Pakistan&width=400&height=400&seq=pkf6p2&orientation=squarish",
      },
      {
        id: "pkf6p3",
        name: "Industrial Gear Set Heavy Duty",
        samplePrice: 220,
        bulkPrice: 82,
        moq: 5,
        category: "Engineering",
        image: "https://readdy.ai/api/search-image?query=industrial%20gear%20set%20heavy%20duty%20metal%20engineering%20machinery%20parts%20white%20background%20product%20photography%20professional%20manufacturing%20Pakistan&width=400&height=400&seq=pkf6p3&orientation=squarish",
      },
    ],
  },
];
